import { NAMESPACE, CONTENT_HEIGHT } from './constants'

function updateHeightCard(card) {
  const answerNode = card.querySelector(`.${NAMESPACE.answer}`)
  const nameNode = card.querySelector(`.${NAMESPACE.name}`)
  const nameHeight = nameNode.offsetHeight
  const newAnswerHeight = CONTENT_HEIGHT - nameHeight

  answerNode.style.height = `${newAnswerHeight}px`
}

function init() {
  const jsNode = document.querySelector(`.${NAMESPACE.js}`)

  // Выполняем js только там где указан модификатор `js`
  if (!jsNode) {
    return
  }

  // необходимо для того, чтобы все карточки с интервью были одной высоты
  window.addEventListener('load', () => {
    const cardNodes = [...document.querySelectorAll(`.${NAMESPACE.card}`)]

    cardNodes.forEach(updateHeightCard)
  })
}

init()
